module.exports = __webpack_public_path__ + "img/dink-kitchen-1.5a82a89b.jpeg";